import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useCopy, useLang } from "@/contexts/LanguageContext";

const STATUSES = ["Submitted", "Acknowledged", "Assigned", "Under investigation", "Awaiting user response", "Resolved", "Closed", "Escalated"];
const COPY = {
  en: { h: "Grievance Management", cols: ["Ticket", "Category", "Priority", "Status", "Update"], ok: "Updated", fail: "Update failed" },
  hi: { h: "शिकायत प्रबंधन", cols: ["टिकट", "श्रेणी", "प्राथमिकता", "स्थिति", "अद्यतन करें"], ok: "अद्यतन हो गया", fail: "अद्यतन विफल" },
};

export default function AdminGrievances() {
  const [items, setItems] = useState([]);
  const c = useCopy(COPY);
  const { tv } = useLang();
  const load = useCallback(() => api.get("/grievances").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const update = async (id, status) => {
    try { await api.patch(`/grievances/${id}`, { status }); toast.success(c.ok); await load(); } catch { toast.error(c.fail); }
  };
  return (
    <div className="space-y-6" data-testid="admin-grievances">
      <div><h1 className="text-3xl font-bold text-slate-900 brand-heading">{c.h}</h1></div>
      <div className="overflow-x-auto table-scroll rounded-lg border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-widest text-slate-500 border-b border-slate-200 bg-slate-50">
            <tr>{c.cols.map((h) => <th key={h} className="py-3 px-4">{h}</th>)}</tr>
          </thead>
          <tbody>
            {items.map((g) => (
              <tr key={g.id} className="border-b border-slate-100" data-testid={`griev-row-${g.id}`}>
                <td className="py-3 px-4 font-mono">{g.ticket_number}</td>
                <td className="py-3 px-4">{tv(g.category)}</td>
                <td className="py-3 px-4">{tv(g.priority)}</td>
                <td className="py-3 px-4"><span className="rounded-full bg-slate-100 border border-slate-200 text-xs px-2 py-0.5">{tv(g.status)}</span></td>
                <td className="py-3 px-4">
                  <select onChange={(e) => update(g.id, e.target.value)} defaultValue={g.status} data-testid={`griev-update-${g.id}`} className="rounded-md border border-slate-300 px-2 py-1 text-xs">
                    {STATUSES.map((o) => <option key={o} value={o}>{tv(o)}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
